import Produit from "./Produit";
import {coefsByFormat} from "../data/Formats";

export default class ProduitEcranEnsemble extends Produit {

  constructor(code, libelle, audienceBase, tarifBase, pressions = [100], semainesIndispo = []) {
    super(code, libelle, 'Entrées', pressions, semainesIndispo);
    this.audienceBase = audienceBase;
    this.tarifBase = tarifBase;
  }

  tarif(semaine, format = 30, pression = 100) {
    if (this.isDisponible(semaine)) {
      const coefPression = (pression === 100 ? 1 : (pression / 100 * 1.05));
      const coefTarif = semaine.coefTarif;
      const coefFormat = coefsByFormat[format];
      const tarifBaseSemaine = this.tarifBase[semaine.codeAudienceTarif]
      const tarif = tarifBaseSemaine * coefTarif * coefPression * coefFormat;
      return tarif.roundN(10);
    } else {
      return 0;
    }
  }

  audience(semaine, pression = 100) {
    if (this.isDisponible(semaine)) {
      const coefAudience = semaine.coefAudience;
      const audience = this.audienceBase[semaine.codeAudienceTarif] * coefAudience * pression / 100;
      return audience.roundN(10);
    } else {
      return 0;
    }
  }
}
